const featureToggles = (state) => state.toggleFeatures
const featureToggleSales = (state) => state.toggleFeatures.sales
const featureToggleCommissions = (state) => state.toggleFeatures.commissions
const featureToggleCommissionsOrders = (state) =>
  state.toggleFeatures.commissionsOrders
const featureToggleTeamMembers = (state) => state.toggleFeatures.teamMembers
const featureToggleSuccessRate = (state) => state.toggleFeatures.success_rate
const featureToggleNotifications = (state) =>
  state.toggleFeatures.notifications
const featureToggleBonus = (state) => state.toggleFeatures.bonus

const cms = (state) => state.cms[state.cmsId]
const cmsLoading = (state) => state.cmsLoading
const cmsError = (state) => state.cmsError

const homepageBlocks = (state) => state.homepageBlocks
const periodList = (state) => state.period
const defaultPeriod = (state) => state.period[0]
const homepageBlocksLoading = (state) => state.homepageBlocksLoading
const homepageBlocksError = (state) => state.homepageBlocksError

const homepageSlider = (state) =>
  state.homepageBlocks &&
  state.homepageBlocks.filter((el) => el.slug === 'hompage.slider')

const homepageReadytoSellItems = (state) =>
  state.homepageBlocks &&
  state.homepageBlocks.filter((el) => el.slug === 'homepage.readytosell')

const pageToolbar = (state) => state.pageToolbar
const pageToolbarTitle = (state) => state.pageToolbarTitle
const pageToolbarSubtitle = (state) => state.pageToolbarSubtitle
const pageToolbarDropdown = (state) => state.pageToolbarDropdown
const pageToolbarSelect = (state) => state.pageToolbarSelect
const pageToolbarDropdownList = (state) => state.pageToolbarDropdownList
const pageToolbarDropdownSelectedItem = (state) =>
  state.pageToolbarDropdownSelectedItem
const pageToolbarButton = (state) => state.pageToolbarButton
const pageToolbarButtonLabel = (state) => state.pageToolbarButtonLabel
const pageToolbarInfoIcon = (state) => state.pageToolbarInfoIcon
const toolbarDropdownConfig = (state) => state.toolbarDropdownConfig
const pageToolbarNotificationIcon = (state) =>
  state.pageToolbarNotificationIcon

const pageDialog = (state) => state.pageDialog
const pageNavigationDrawer = (state) => state.pageNavigationDrawer
const pageBottomNavigation = (state) => state.pageBottomNavigation
const pageLayoutType = (state) => {
  if (state.device === 'desktop') return state.pageDesktopLayoutType
  return state.pageMobileLayoutType
}
const pageSelectedMenu = (state) => {
  if (state.device === 'desktop') return state.pageDesktopSelectedMenu
  return state.pageMobileSelectedMenu
}

const isSecondaryPage = (state) => {
  if (state.device === 'desktop') { return state.pageDesktopLayoutType === 'secondary' }
  return state.pageMobileLayoutType === 'secondary'
}
const isFunnelPage = (state) => {
  if (state.device === 'desktop') { return state.pageDesktopLayoutType === 'funnel' }
  return state.pageMobileLayoutType === 'funnel'
}
const isDesktop = (state) => state.device === 'desktop'
const isMobile = (state) => state.device === 'mobile'
const savingForm = (state) => state.savingForm
const loadingPage = (state) => state.loadingPage
const lang = (state) => state.lang
const prevPeriod = (state) => state.prevPeriod
const tabs = (state, getters, rootState, rootGetters) => {

  return [
    {
      icon: 'home',
      i18n: 'menu.home',
      page: 'home',
      mobile: false,
      desktop: true,
      enabled: true,
      separator: true,
      hasCounter: false
    },
    {
      header: 'menu.performance',
      enabled: state.toggleFeatures.sales
    },
    {
      icon: 'trending_up',
      i18n: 'menu.sales',
      page: 'sales',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.sales,
      hasCounter: false
    },
    {
      icon: 'attach_money',
      i18n: 'menu.commissions',
      page: 'commissions',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.commissions,
      hasCounter: false
    },
    {
      icon: 'local_play',
      i18n: 'menu.bonuses',
      page: 'bonuses-list',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.bonus,
      hasCounter: false
    },
    {
      header: 'menu.orders',
      enabled: state.toggleFeatures.orders
    },
    {
      icon: 'shopping_basket',
      i18n: 'menu.orders',
      page: 'orders-list',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.orders,
      hasCounter: false
    },
    {
      header: 'menu.success_rate',
      enabled: state.toggleFeatures.success_rate
    },
    {
      icon: 'assessment',
      i18n: 'menu.success_rate',
      page: 'sr-configs-list',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.success_rate,
      hasCounter: false
    },
    {
      header: 'menu.affiliate',
      enabled: state.toggleFeatures.affiliate
    },
    {
      icon: 'code',
      i18n: 'menu.affiliate_link',
      page: 'affiliate-link',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.affiliate || state.toggleFeatures.affiliateLink,
      hasCounter: false
    },
    {
      header: 'menu.team',
      enabled:
        state.toggleFeatures.teamMembers || state.toggleFeatures.teamLeader
    },
    {
      icon: 'people',
      i18n: 'menu.team_members',
      page: 'team-members-list',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.teamMembers,
      hasCounter: false
    },
    {
      icon: 'person',
      i18n: 'menu.team_leader',
      page: 'team-leader',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.teamLeader,
      hasCounter: false
    },
    {
      header: 'menu.account',
      enabled: (state.toggleFeatures.personalInfo || state.toggleFeatures.paymentMethods || state.toggleFeatures.levels)
    },
    {
      icon: rootGetters['user/isStore'] ? 'store' : 'person',
      i18n: rootGetters['user/isStore']
        ? 'menu.store_info'
        : 'menu.personal_info',
      page: 'personal-info',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.personalInfo,
      hasCounter: false
    },
    {
      icon: 'notifications',
      i18n: 'menu.notifications',
      page: 'notifications-list',
      mobile: false,
      desktop: true,
      enabled: state.toggleFeatures.notifications,
      hasCounter: true
    },
    {
      icon: 'credit_card',
      i18n: 'menu.payment_account',
      page: 'payment-method',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.paymentMethods && !state.hidePayment && !rootState.user.isImpersonate,
      hasCounter: false
    },
    {
      icon: 'assessment',
      i18n: 'menu.level',
      page: 'level-info',
      mobile: true,
      desktop: true,
      enabled: state.toggleFeatures.levels,
      hasCounter: false
    }
  ]
}

export default {
  featureToggles,
  featureToggleSales,
  featureToggleCommissions,
  featureToggleCommissionsOrders,
  featureToggleTeamMembers,
  featureToggleSuccessRate,
  featureToggleNotifications,
  featureToggleBonus,

  cms,
  cmsLoading,
  cmsError,

  homepageBlocks,
  periodList,
  defaultPeriod,
  homepageSlider,
  homepageReadytoSellItems,
  homepageBlocksLoading,
  homepageBlocksError,

  pageToolbar,
  toolbarDropdownConfig,
  pageToolbarTitle,
  pageToolbarSubtitle,
  pageToolbarDropdown,
  pageToolbarSelect,
  pageToolbarDropdownList,
  pageToolbarDropdownSelectedItem,
  pageToolbarButton,
  pageToolbarButtonLabel,
  pageToolbarInfoIcon,
  pageToolbarNotificationIcon,
  pageDialog,
  pageNavigationDrawer,
  pageBottomNavigation,
  pageLayoutType,
  pageSelectedMenu,

  savingForm,
  isSecondaryPage,
  isFunnelPage,
  isMobile,
  isDesktop,
  loadingPage,
  lang,
  tabs,
  prevPeriod
}
